import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
export default function TimePickerButton(_ref) {
  var _classnames;

  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      showTimePicker = _ref.showTimePicker,
      onOpenTimePicker = _ref.onOpenTimePicker,
      onCloseTimePicker = _ref.onCloseTimePicker,
      timePickerDisabled = _ref.timePickerDisabled;
  var className = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-time-picker-btn"), true), _defineProperty(_classnames, "".concat(prefixCls, "-time-picker-btn-disabled"), timePickerDisabled), _classnames));
  var onClick = null;

  if (!timePickerDisabled) {
    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
  }

  return /*#__PURE__*/React.createElement("a", {
    className: className,
    role: "button",
    onClick: onClick
  }, showTimePicker ? locale.dateSelect : locale.timeSelect);
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/calendar/TimePickerButton.js